@if (busyService.isBusy()) {
  <div class="overlay">
    <div class="spinner">
      <mat-progress-spinner mode="indeterminate" diameter="60"></mat-progress-spinner>
      <div class="text">Please wait...</div>
    </div>
  </div>
}
